// src/components/Layout.js
import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const roleLabel = { admin:'ئەدمین', data_entry:'داخڵکەری داتا', viewer:'بینەر', report:'ڕاپۆرت' };

export default function Layout() {
  const { user, logout, can } = useAuth();
  const nav = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); nav('/login'); };

  const links = [
    { to:'/', label:'داشبۆرد', icon:'📊', always:true },
    { to:'/forms', label:'فۆرمەکان', icon:'📋', always:true },
    { to:'/forms/new', label:'فۆرمی نوێ', icon:'➕', perm:'create' },
    { to:'/reports', label:'ڕاپۆرتەکان', icon:'📈', perm:'report' },
    { to:'/bulk-upload', label:'ئەپلۆدی بەکۆمەڵ', icon:'📤', perm:'manage' },
    { to:'/departments', label:'بەشەکان', icon:'🏢', perm:'manage' },
    { to:'/users', label:'بەکارهێنەران', icon:'👥', perm:'manage' },
  ].filter(l => l.always || can(l.perm));

  return (
    <div style={styles.shell}>
      {/* Sidebar */}
      <aside style={{...styles.sidebar, width: collapsed ? 64 : 220}}>
        <div style={styles.sideTop}>
          <div style={styles.brandRow} onClick={() => setCollapsed(!collapsed)}>
            {!collapsed && <span style={styles.brand}>KRG Allowance</span>}
            <span style={{cursor:'pointer', fontSize:18}}>☰</span>
          </div>
          <nav style={styles.nav}>
            {links.map(l => (
              <NavLink key={l.to} to={l.to} end={l.to==='/'} style={({isActive}) => ({
                ...styles.link, background: isActive ? 'rgba(255,255,255,0.2)' : 'transparent'
              })}>
                <span style={{fontSize:18}}>{l.icon}</span>
                {!collapsed && <span style={styles.linkLabel}>{l.label}</span>}
              </NavLink>
            ))}
          </nav>
        </div>
        <div style={styles.userBox}>
          {!collapsed && (
            <>
              <div style={styles.userName}>{user?.full_name}</div>
              <div style={styles.userRole}>{roleLabel[user?.role]}</div>
              {user?.dept_name && <div style={styles.deptName}>{user.dept_name}</div>}
            </>
          )}
          <button onClick={handleLogout} style={styles.logoutBtn} title="چوونەدەرەوە">
            {collapsed ? '🚪' : '🚪 چوونەدەرەوە'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

const styles = {
  shell: { display:'flex', minHeight:'100vh', fontFamily:'Traditional Arabic,Arial,sans-serif', direction:'rtl' },
  sidebar: { background:'linear-gradient(180deg,#1a5276 0%,#154360 100%)', color:'#fff', display:'flex', flexDirection:'column', justifyContent:'space-between', transition:'width 0.2s', overflow:'hidden', flexShrink:0 },
  sideTop: { display:'flex', flexDirection:'column' },
  brandRow: { padding:'16px 14px', display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid rgba(255,255,255,0.15)', cursor:'pointer' },
  brand: { fontWeight:'bold', fontSize:14, whiteSpace:'nowrap' },
  nav: { display:'flex', flexDirection:'column', padding:'8px 0' },
  link: { display:'flex', alignItems:'center', gap:10, padding:'10px 14px', color:'#fff', textDecoration:'none', borderRadius:6, margin:'2px 6px', transition:'background 0.15s', whiteSpace:'nowrap' },
  linkLabel: { fontSize:13 },
  userBox: { padding:12, borderTop:'1px solid rgba(255,255,255,0.15)', display:'flex', flexDirection:'column', gap:4 },
  userName: { fontWeight:'bold', fontSize:13, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  userRole: { fontSize:11, color:'rgba(255,255,255,0.7)', background:'rgba(255,255,255,0.15)', borderRadius:10, padding:'1px 8px', display:'inline-block' },
  deptName: { fontSize:10, color:'rgba(255,255,255,0.6)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  logoutBtn: { background:'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:6, padding:'6px 10px', cursor:'pointer', fontSize:12, textAlign:'right', marginTop:4 },
  main: { flex:1, background:'#f4f6f9', overflow:'auto' },
};
